import { createApp } from "vue";
import { createPinia } from "pinia";
import * as Sentry from "@sentry/vue";

import App from "./App.vue";
import router from "./router";

import "./assets/main.css";

import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { plugin, defaultConfig } from "@formkit/vue";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

const app = createApp(App);

if (import.meta.env.PROD && import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
      new Sentry.Replay(),
    ],
    // Capture 100% of transactions for performance monitoring.
    tracesSampleRate: 1.0,
    // Record 10% of sessions; 100% of sessions with errors.
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

app.use(createPinia());
app.use(router);
app.component("v-select", vSelect);
app.component("VueDatePicker", VueDatePicker);
app.use(plugin, defaultConfig);

// Wait for the router's initial navigation (including the async beforeEach
// guard — cookie check, /api/userAdmin hydration, org/verification/onboarding
// checks) to resolve before mounting. Without this, App.vue's onMounted can
// fire while useRoute() still holds the router's default unresolved state
// (path "/", empty meta) instead of the actually-requested URL, which made
// its own legacy checkRouteGuard() misread every hard-loaded route as "/"
// and incorrectly bounce public routes like /register or /accept-invite/:id
// to /login before they ever rendered.
router.isReady().then(() => {
  app.mount("#app");
});
